module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAIAAAD9iXMrAAAAHElEQVQoFWP8/O0HAxGAiQg1ICWj6rAH1GAPFwDv/AL75HAqTwAAAABJRU5ErkJggg=="